import { useCallback } from 'react';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function useGtm() {
  const pushToDataLayer = useCallback((eventData: Record<string, unknown>) => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    }
  }, []);

  return { pushToDataLayer };
}
